export { default as MainLayout } from './Main/MainLayout';
export { default as AuthLayout } from './Auth/AuthLayout';



// WEBPACK FOOTER //
// ./src/components/Layout/index.js